import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"],
  _excluded2 = ["size"],
  _excluded3 = ["size"],
  _excluded4 = ["size"],
  _excluded5 = ["size"],
  _excluded6 = ["size"],
  _excluded7 = ["initialHeight", "position"];
import React from 'react';
import { StyledLoading, StyledLoadingOverlay, StyledSpinnerIconGrey, StyledSpinnerIconPrimary, StyledSpinnerIconSecondary } from './Loading.styled';
import { StyledSpinnerRingIcon } from './LoadingRing.styled';
export var LoadingPrimary = createLoading(LoadingIconPrimary);
export var LoadingSecondary = createLoading(LoadingIconSecondary);
export var LoadingGrey = createLoading(LoadingIconGrey);

/** A content overlay loading state that uses the primaryAppBackground theme color. */
export function LoadingOverlayPrimary(_ref) {
  var size = _ref.size,
    htmlProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledLoadingOverlay, htmlProps, /*#__PURE__*/React.createElement(LoadingIconPrimary, {
    size: size
  }));
}

/** A content overlay loading state that uses the secondaryAppBackground theme color. */
export function LoadingOverlaySecondary(_ref2) {
  var size = _ref2.size,
    htmlProps = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(StyledLoadingOverlay, htmlProps, /*#__PURE__*/React.createElement(LoadingIconPrimary, {
    size: size
  }));
}

/** @deprecated use LoadingOverlaySecondary instead */
export var LoadingOverlay = LoadingOverlaySecondary;
export function LoadingIconPrimary(_ref3) {
  var size = _ref3.size,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(StyledSpinnerIconPrimary, _extends({
    size: size || 24
  }, props));
}
export function LoadingIconSecondary(_ref4) {
  var size = _ref4.size,
    props = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(StyledSpinnerIconSecondary, _extends({
    size: size || 24
  }, props));
}
export function LoadingIconGrey(_ref5) {
  var size = _ref5.size,
    props = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(StyledSpinnerIconGrey, _extends({
    size: size || 24
  }, props));
}
export function LoadingRingIcon(_ref6) {
  var size = _ref6.size,
    props = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/React.createElement(StyledSpinnerRingIcon, _extends({
    size: size || 24
  }, props));
}
function createLoading(LoadingIconType) {
  return function LoadingWrapper(props) {
    var _props$initialHeight = props.initialHeight,
      initialHeight = _props$initialHeight === void 0 ? 50 : _props$initialHeight,
      position = props.position,
      loading = _objectWithoutProperties(props, _excluded7);
    var style = {
      minHeight: initialHeight,
      position: position
    };
    return /*#__PURE__*/React.createElement(StyledLoading, {
      style: style
    }, /*#__PURE__*/React.createElement(LoadingIconType, loading));
  };
}